import { buttonCoreDriverFactory } from '../Button/ButtonCore/ButtonCore.uni.driver';

export const textButtonDriverFactory = buttonCoreDriverFactory;

export type TextButtonUniDriver = ReturnType<typeof textButtonDriverFactory>;
